import React, { useState } from 'react';
import { FiInfo } from 'react-icons/fi';
import i18n from '@pureartisan/simple-i18n';
import { Tooltip } from 'reactstrap';

var makeId = function makeId() {
  return '_' + Math.random().toString(36).substr(2, 9);
};

var IndicatorTooltip = function IndicatorTooltip(_ref) {
  var indicator = _ref.indicator,
      size = _ref.size;

  var _useState = useState(false),
      tooltipOpen = _useState[0],
      setTooltipOpen = _useState[1];

  var toggle = function toggle() {
    return setTooltipOpen(!tooltipOpen);
  };

  var _useState2 = useState(makeId()),
      elId = _useState2[0]; // prevent duplicate ids


  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FiInfo, {
    className: "indicator-tip",
    style: {
      fontSize: size
    },
    id: elId
  }), /*#__PURE__*/React.createElement(Tooltip, {
    placement: "top",
    isOpen: tooltipOpen,
    target: elId,
    toggle: toggle,
    autohide: false,
    dangerouslySetInnerHTML: {
      __html: i18n.translate(indicator.id + "_desc")
    }
  }));
};

export default IndicatorTooltip;